import { Injectable } from "@angular/core";
import * as XLSX from "xlsx";
import { GenEnum } from '../../@constant/general.enum';

@Injectable()
export class ExcelService {
  constructor() { }

  static toExportFileName(excelFileName: string): string {
    if(excelFileName != ""){
      return `${excelFileName}.xlsx`;
    }
    else{
      return `export_${new Date().getTime()}.xlsx`;
    }
  }

  public exportAsExcelFile(json: any[], excelFileName: string, format: number): void {
    var wscols = [];
    var value = undefined;
    let objectMaxLength: any = {};
    for (let i = 0; i < json.length; i++) {
      value = <any>Object.keys(json[i]);
      for (let j = 0; j < value.length; j++) {
        if (typeof value[j] === "number") {
          objectMaxLength[j] = 10;
        } else {
          objectMaxLength[j] =
            objectMaxLength[j] >= value[j].length
              ? objectMaxLength[j]
              : value[j].length;
          wscols.push({ wch: objectMaxLength[j] + 5 });
        }
      }
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
      header: value,
      cellStyles: true,
    });

    if (wscols && wscols.length > 0) worksheet["!cols"] = wscols;

    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    let caption = ExcelService.toExportFileName(excelFileName);
    
    let booktype: any = format === GenEnum.FileType.Excel ? "xlsx" : "csv";
    XLSX.writeFile(workbook, caption, {
      bookType: booktype,
      type: "buffer",
      cellStyles: true,
    });
    
  }
}
